module.exports = __webpack_public_path__ + "img/legs.f0d5de62.jpg";